import { getBulkPriceWhenExists } from '../../utils/bulkPrices'
import { useProductDetailState } from './ProductDetailProvider'
import { useTranslate } from '../../utils/translate'

export interface PriceReferenceProps {
  lowestRefPriceFormatted: string | null
  basePriceFormatted: string
  bulkPrices: Core.BulkPrice[] | null
  className?: string
}

export default function PriceReference({
  lowestRefPriceFormatted,
  basePriceFormatted,
  bulkPrices,
  className,
}: Readonly<PriceReferenceProps>) {
  const { quantity } = useProductDetailState()
  const t = useTranslate('shop')

  const price = getBulkPriceWhenExists(bulkPrices, quantity) ?? lowestRefPriceFormatted ?? basePriceFormatted

  return (
    <span className={className}>
      <span className="visually-hidden">
        {t('components.productComponent.referencePrice.accessibilityLabel', {
          price,
        })}
      </span>
      <span aria-hidden="true">({price})</span>
    </span>
  )
}
